import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAccount from "../../../hooks/useAccount";
import productActions from "../../../store/actions/items/item.actions";
import validationHelper from "../../../helpers/validation.helper";
import ItemCardComponent from "../../items/itemCard/ItemCardComponent";
import { useSearchParams } from "react-router-dom";

export const ShoppingCartRecommendedItemsDialogComponent = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [recommendedItems, setRecommendedItems] = useState([]);
  const cartItemList = useSelector((state) => state.shoppingCart.shoppingCartItems);
  const { userInfo } = useAccount();

  useEffect(() => {
    if (cartItemList.length > 0) {
      fetchRecommendedItems();
    }
  }, [cartItemList, userInfo]);

  const fetchRecommendedItems = async () => {
    try {
      const params = {
        pageNumber: 1,
        Rivhit_CustomerId: userInfo?.businessCustomer?.customerId,
        ExcludeItemList: cartItemList.map((item) => item.id),
      };
      const response = await dispatch(productActions.getItems(params));
      if (validationHelper.validateHttpResponse(response) && response.payload.items) {
        setRecommendedItems(response.payload.items);
      } else {
        handleClose();
      }
    } catch (err) {
      // setRecLoading(false);
      handleClose();
      console.error("Error fetching recommended items", err);
    }
  };

  const handleClose = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    // Remove the dialog-related query parameters
    newSearchParams.delete("d");
    newSearchParams.delete("action");
    setSearchParams(newSearchParams);
  };

  const getProductCardElement = (product) => {
    const productCardProps = { product, showMoreDetailsButton: false };
    return <ItemCardComponent key={product.id} props={productCardProps} />;
  };

  return (
    <div className="dialogContainer">
      <h3>מומלצים בשבילך</h3>
      <h5>ריכזנו עבורך את המוצרים המומלצים שעדיין לא הוספת לסל הקניות</h5>
      <div className="productListContainer">{recommendedItems.map((product) => getProductCardElement(product))}</div>
    </div>
  );
};

export default ShoppingCartRecommendedItemsDialogComponent;
